
export interface ResumeSGChargeSearchCriteria {
    opsDateFrom?: Date | null,
    opsDateTo?: Date | null,
    consortiumCode?: string | null,
    vesselCode?: string | null,
    voyageCode?: string | null,
    chargeType?: string | null,
    subChargeType?: string | null,
    // createdDateFrom: Date | null,
    // createdDateTo: Date | null,

    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_RESUME_SG_CHARGE_SEARCH_CRITERIA: ResumeSGChargeSearchCriteria = {
    opsDateFrom: null,
    opsDateTo: null,
    consortiumCode: null,
    vesselCode: '',
    voyageCode: '',
    chargeType: null,
    subChargeType: null,
    // createdDateFrom: null,
    // createdDateTo: null
}